<template>
    <div id="fund-destinations-products">
        <section class="section" :class="needsPadding ? 'section-padding' : ''">
            <div class="container">
                <div class="section-heading heading-left mb-0">
                    <span class="subtitle primary">
                        <slot name="subtitle"></slot>
                    </span>
                    <div class="row">
                        <div class="col-lg-12 mb--30">
                            <h2 class="font-weight-100">
                                <slot name="title"></slot>
                            </h2>
                        </div>
                        <div class="col-lg-12">
                            <div class="row">
                                <div class="col-lg-4 col-xl-4 col-sm-12 col-md-6" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="100">
                                    <ImageCard 
                                        title="Energía."
                                        avatar="energia"
                                        :list="[
                                            'Paneles solares',
                                            'Calentadores solares',
                                            'Refrigeradores, vitrinas y aire acondicionado',
                                            'Iluminación eficiente. (LED)'
                                            ]"
                                        bgImg="energia"
                                    />
                                </div>
                                <div class="col-lg-4 col-xl-4 col-sm-12 col-md-6" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="200">
                                    <ImageCard 
                                        title="Movilidad."
                                        avatar="movilidad"
                                        :list="['Vehiculos híbridos', 'Vehiculos eléctricos']"
                                        bgImg="movilidad"
                                    />
                                </div>
                                <div class="col-lg-4 col-xl-4 col-sm-12 col-md-6" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="200">
                                    <ImageCard 
                                        title="Agua."
                                        :avatar="null"
                                        :isBanner="true"
                                        :list="['Dispositivos ahorradores de agua.', 'Captación y almacenamiento.', 'Sistemas de filtración y saneamiento.']"
                                        bgImg="water"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ImageCard from '../partials/image-card.vue';
export default {
    name: "FundDestinations",
    props: ["needsPadding"],
    components: {
        ImageCard
    }
}

</script>

<style scoped>

</style>